<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardHeader>
                    <strong>Редактирование тригерной рассылки #{{ campaignId }}</strong>
                </CCardHeader>
                <CCardBody>
                    <div v-if="initialLoading" class="text-center">
                        <CSpinner color="primary"/>
                    </div>
                    <TriggerCampaignForm
                        v-else
                        :campaign="campaign"
                        :segments="segments"
                        :loading="loading"
                        @submit="handleSubmit"
                        @cancel="handleCancel"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import TriggerCampaignForm from '../../components/trigger-campaigns/TriggerCampaignForm.vue';

    export default {
        name: 'TriggerCampaignEdit',

        components: {
            TriggerCampaignForm
        },

        data() {
            return {
                initialLoading: true,
                loading: false,
                segments: [],
                campaign: {
                    name: '',
                    segment_id: null,
                    trigger_type: 'registration',
                    trigger_days: 1,
                    trigger_hours: null,
                    send_time: '10:00',
                    push_title: '',
                    push_text: '',
                    click_url: '',
                    enabled: true
                }
            };
        },

        computed: {
            campaignId() {
                return this.$route.params.id;
            }
        },

        async mounted() {
            await Promise.all([
                this.loadCampaign(),
                this.loadSegments()
            ]);
            this.initialLoading = false;
        },

        methods: {
            async loadCampaign() {
                try {
                    const response = await Vue.axios.get(`/trigger-campaigns/${this.campaignId}`);
                    this.campaign = response.data;
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки тригерной рассылки.');
                    console.error(err);
                }
            },

            async loadSegments() {
                try {
                    const response = await Vue.axios.get('/segments');
                    this.segments = response.data.data || [];
                } catch (err) {
                    console.error('Ошибка загрузки сегментов:', err);
                    this.segments = [];
                }
            },

            async handleSubmit(campaignData) {
                this.loading = true;
                try {
                    await Vue.axios.put(`/trigger-campaigns/${this.campaignId}`, campaignData);
                    this.$root.$emit('showSuccess', 'Тригерная рассылка обновлена.');
                    this.$router.push(`/trigger-campaigns/${this.campaignId}`);
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка обновления тригерной рассылки.');
                    console.error(err);
                } finally {
                    this.loading = false;
                }
            },

            handleCancel() {
                this.$router.push(`/trigger-campaigns/${this.campaignId}`);
            }
        }
    };
</script>
